import { Box } from "@mui/material";

import NodesPageHeader from "./components/NodesPageHeader";
import NodesTable from "./components/NodesTable";

const NodesPage = (): JSX.Element => {
  return (
    <Box>
      <NodesPageHeader />
      <NodesTable />
    </Box>
  );
};

export default NodesPage;
